export const DEFAULT_TAX_CONFIG = {
  rate_wholesale: 0.001,
  rate_retail: 0.0015,
  rate_biz: 0.004,
  threshold_wholesale: 2,
  threshold_retail: 2,
  threshold_biz: 10,
  license_fee: 15,
  penalty_rate: 0.1,
  interest_rate: 0.0125,
  confirmation_prefix: "CHT",
};

const lineTax = (gross, rate, threshold) => {
  const tax = Math.round(gross * rate * 100) / 100;
  return tax < threshold ? 0 : tax;
};

export function computeFiling(f, cfg = {}) {
  const c = { ...DEFAULT_TAX_CONFIG, ...(cfg || {}) };
  const num = (v) => (isNaN(parseFloat(v)) ? 0 : parseFloat(v));
  const r = (v) => Math.round(v * 100) / 100;

  const l1a = lineTax(num(f.wholesale_2025), c.rate_wholesale, c.threshold_wholesale);
  const l1b = lineTax(num(f.retail_2025), c.rate_retail, c.threshold_retail);
  const l1c = lineTax(num(f.biz_2025), c.rate_biz, c.threshold_biz);
  const l2 = r(l1a + l1b + l1c);
  const l3 = r(num(f.estimated_tax_paid_2025));
  const l4 = r(l2 - l3);
  const base4 = Math.max(l4, 0);
  const months = Math.max(parseInt(f.months_late) || 0, 0);
  const l5 = f.paid_late ? r(base4 * c.penalty_rate) : 0;
  const l6 = f.paid_late ? r(base4 * c.interest_rate * months) : 0;
  const l7 = r(l4 + l5 + l6);

  const l8a = lineTax(num(f.wholesale_2026), c.rate_wholesale, c.threshold_wholesale);
  const l8b = lineTax(num(f.retail_2026), c.rate_retail, c.threshold_retail);
  const l8c = lineTax(num(f.biz_2026), c.rate_biz, c.threshold_biz);
  const l9 = r(l8a + l8b + l8c);
  const l10 = f.paid_late ? r(l9 * c.penalty_rate) : 0;
  const l11 = f.paid_late ? r(l9 * c.interest_rate * months) : 0;
  const cats = (f.cat_wholesale ? 1 : 0) + (f.cat_retail ? 1 : 0) + (f.cat_biz ? 1 : 0);
  const l12 = r(c.license_fee * cats);
  const l13 = r(l9 + l10 + l11 + l12);

  const l14 = r(l7 + l13);

  return { l1a, l1b, l1c, l2, l3, l4, l5, l6, l7, l8a, l8b, l8c, l9, l10, l11, l12, l13, l14 };
}

export const money = (v) =>
  (v ?? 0).toLocaleString("en-US", { style: "currency", currency: "USD" });
